/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamComponentTypesQueryResponse,
  GetApiV1ExamComponentTypes400,
  GetApiV1ExamComponentTypes401,
  GetApiV1ExamComponentTypes500,
} from "../../types/examSharedController/GetApiV1ExamComponentTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamComponentTypes } from "../../clients/examSharedController/getApiV1ExamComponentTypes.ts";

export const getApiV1ExamComponentTypesQueryKey = () =>
  [{ url: "/api/v1/exam/component-types" }] as const;

export type GetApiV1ExamComponentTypesQueryKey = ReturnType<
  typeof getApiV1ExamComponentTypesQueryKey
>;

export function getApiV1ExamComponentTypesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamComponentTypesQueryKey();
  return queryOptions<
    GetApiV1ExamComponentTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamComponentTypes400
      | GetApiV1ExamComponentTypes401
      | GetApiV1ExamComponentTypes500
    >,
    GetApiV1ExamComponentTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamComponentTypes({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os tipos de componentes **(Requer Authorization para autenticação)**
 * @summary Buscar todos os tipos de componentes (Requer Authorization para autenticação)
 * {@link /api/v1/exam/component-types}
 */
export function useGetApiV1ExamComponentTypes<
  TData = GetApiV1ExamComponentTypesQueryResponse,
  TQueryData = GetApiV1ExamComponentTypesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamComponentTypesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamComponentTypesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamComponentTypes400
          | GetApiV1ExamComponentTypes401
          | GetApiV1ExamComponentTypes500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamComponentTypesQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamComponentTypesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamComponentTypes400
      | GetApiV1ExamComponentTypes401
      | GetApiV1ExamComponentTypes500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
